module.exports = __webpack_public_path__ + "assets/File-signature.5942fb36.svg";